import { gql } from '@apollo/client';
export const CAREPLAN_TEMPLATE_REQUEST_CHANGE = gql`
  mutation CareplanTemplateChange($careplanId: ID!, $status: String) {
    templateChangeRequest(careplanId: $careplanId, status: $status) {
      id
      status
    }
  }
`;
